import React from 'react';

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17316C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761204C12.6136 0.258658 11.3132 0 10 0ZM14.3 7.61L9.73 13.61C9.63684 13.731 9.51721 13.8291 9.38027 13.8967C9.24333 13.9643 9.09272 13.9996 8.94 14C8.78811 14.0008 8.63803 13.967 8.50114 13.9012C8.36426 13.8353 8.24418 13.7392 8.15 13.62L5.71 10.51C5.5469 10.3005 5.4737 10.0347 5.50652 9.77125C5.53934 9.50776 5.67548 9.2681 5.885 9.105C6.09452 8.94189 6.36026 8.86869 6.62375 8.90151C6.88724 8.93433 7.12689 9.07048 7.29 9.28L8.92 11.36L12.7 6.36C12.7801 6.25494 12.8801 6.16669 12.9943 6.10028C13.1085 6.03388 13.2347 5.99062 13.3657 5.97298C13.4966 5.95533 13.6297 5.96365 13.7574 5.99746C13.8851 6.03126 14.0049 6.08989 14.11 6.17C14.2151 6.2501 14.3033 6.35012 14.3697 6.46433C14.4361 6.57854 14.4794 6.70472 14.497 6.83565C14.5147 6.96658 14.5063 7.0997 14.4725 7.22742C14.4387 7.35513 14.3801 7.47494 14.3 7.58V7.61Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-0.874998"
        y1="30.2381"
        x2="35.9391"
        y2="27.1022"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E26E43" />
        <stop offset="1" stopColor="#F8CE0E" />
      </linearGradient>
    </defs>
  </svg>
);
